module.exports = __webpack_public_path__ + "static/media/15-7.a31a21b5.mp3";